<template>
  <div class="content">
    <!-- 内容详情start -->
    <div class="">
      <el-row>
        <el-col :span="5">
          <div class="grid-content"></div>
        </el-col>
        <el-col :span="13">
          <div class="grid-content">
            <el-tag v-if="detail.detail.tieziType=='1'" type="danger">
              投诉-{{detail.detail.serviceItemName}}-{{detail.detail.serviceItemIdName}}
            </el-tag>
            <el-tag v-if="detail.detail.tieziType=='2'" type="warning">
              建议-{{detail.detail.serviceItemName}}-{{detail.detail.serviceItemIdName}}
            </el-tag>
            <el-tag v-if="detail.detail.tieziType=='3'" type="warning">
              咨询-{{detail.detail.serviceItemName}}-{{detail.detail.serviceItemIdName}}
            </el-tag>
            <el-tag v-if="detail.detail.tieziType=='4'" type="warning">
              表扬-{{detail.detail.serviceItemName}}-{{detail.detail.serviceItemIdName}}
            </el-tag>
            <span style="padding-left:20px"><strong>{{detail.detail.title}}</strong></span>

          </div>
        </el-col>

        <el-col :span="1" style=" line-height:35px; ">


          <img src="../../assets/like.png" alt="" width="14px" style="padding-top:12px" @click="like"
               v-if="isLike == false">
          <img src="../../assets/like2.png" alt="" width="14px" style="padding-top:12px;" @click="dislike"
               v-if="isLike == true">
          <span style="font-size:16px;">{{detail.detail.greatCount}}</span>
        </el-col>

      </el-row>

      <el-row style="padding-top:15px;">
        <el-col :span="5">
          <div class="grid-content"></div>
        </el-col>
        <el-col :span="14">
          <div class="grid-content">
            <el-container>
              <el-aside width="180px" height="500px" class="DeatilAside">
                <!-- 侧边内容 头像 作者 发帖数 跟帖数 -->
                <div class="headPictureWraper">
                  <img class="headPicture" src="../../assets/head.jpg" alt="">
                </div>
                <h5 style="text-align:center">{{detail.detail.userName}}</h5>
                <!-- <h5 style="text-align:center">发帖数：{{detail.detail.publish}}</h5>
                <h5 style="text-align:center">跟帖数：{{detail.detail.follow}}</h5> -->
              </el-aside>
              <el-main class="DetailMain">
                <div class="">
                  <el-tag type="success"><strong>楼主</strong></el-tag>
                </div>
                <div class="">
                  {{detail.detail.content}}
                </div>
                <div class="date">
                  <span style="font-size:13px">{{detail.detail.createDate}}</span>
                </div>
              </el-main>
            </el-container>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="grid-content"></div>
        </el-col>

        <el-col :span="19" v-if="detail.detail.image != ''" style="padding-left:185px;">
          <img v-for="(url,idx) in detail.detail.image" :key="idx" :src="url "
               style="width: 100px; height: 100px; margin-left:8px;padding-top:5px; padding-left:5px" preview
               preview-text="">
        </el-col>


      </el-row>
    </div>
    <!-- 内容详情end -->

    <div class="" style="margin-top:20px">
      <el-row>
        <el-col :span="5">
          <div class="grid-content"></div>
        </el-col>

        <el-col :span="5">
          <div class="grid-content"></div>
        </el-col>
      </el-row>
    </div>


    <!-- 评论start -->
    <div class="">
      <el-row style="padding-bottom:10px;" v-for="item in detail.comments" :key="item.id">
        <el-col :span="5">
          <div class="grid-content"></div>
        </el-col>
        <el-col :span="14">
          <div class="grid-content">
            <el-container>
              <el-aside width="180px" height="500px" class="DeatilAside">
                <!-- 侧边内容 头像 作者 发帖数 跟帖数 -->
                <div style="text-align:center">

                </div>
                <div class="headPictureWraper">

                  <img class="headPicture" src="../../assets/head.jpg" alt="">
                </div>
                <!-- <div>
                  {{item.greatCount}}
                </div> -->

                <h5 style="text-align:center">{{item.realName}}</h5>
                <!-- <h5 style="text-align:center">发帖数：{{item.publish}}</h5>
                <h5 style="text-align:center">跟帖数：{{item.follow }}</h5> -->
              </el-aside>
              <el-main class="DetailMain">
                <div class="">
                  <div class="">

                    <el-tag type="danger" v-if="item.roleType == 1"><strong>官方</strong></el-tag>
                  </div>
                  <!-- <div class="">
                    <el-tag type="success" v-if="item.userId == detail.detail.userId"><strong>楼主</strong></el-tag>
                  </div> -->
                  {{item.commentContent}}
                </div>
                <div class="date">
                  <span style="font-size:13px">{{item.createDate}}</span>


                </div>
                <span class="bottom">

                <img src="../../assets/like.png" alt="" width="14px" style="padding-top:12px" @click="commentLike(item)"
                     v-if="item.commentIsLike == false">
                <img src="../../assets/like2.png" alt="" width="14px" style="padding-top:12px;"
                     @click="commentDislike(item)" v-if="item.commentIsLike == true">
                <span style="font-size:14px">{{item.greatNum}}</span>
              </span>
              </el-main>
            </el-container>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content"></div>
        </el-col>
      </el-row>
    </div>
    <!-- 评论end -->


    <!-- 分页start -->
    <div class="">
      <el-row style="text-align:center; padding-top:10px">
        <el-pagination background layout="prev, pager, next" :total="detail.commentsCount" :page-size="params.size"
                       @current-change="handleCurrentChange" :current-page.sync="params.page"></el-pagination>
      </el-row>
    </div>
    <!-- 分页end -->
    <el-footer></el-footer>

    <!-- 回复start -->
    <el-row>
      <el-col :span="5">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="14">
        <div class="grid-content">
          <el-input rows=5 type="textarea" placeholder="回复..." v-model="params.reply"></el-input>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="5">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="14">
        <div class="grid-content">
          <el-button type="primary" style="float:right; margin-top:5px" @click="handleReply">提交</el-button>
        </div>
      </el-col>
    </el-row>
    <!-- 回复end -->
  </div>
</template>

<script>

  import {
    commentMinusGreatCount,
    getPostDetail,
    addBrowseCount,
    commentAddGreatCount,
    minusGreatCount,
    addGreatCount,
    addComment,
    OK,
    HOST,
  } from '../../api/data.js'

  export default {
    name: 'ComplaintsAndSuggestionsForm',
    data() {
      return {
        psl: [],
        userInfo: [],
        commonts: '',
        detail: {},
        params: {
          id: '',
          page: 1,
          size: 10,
          reply: ''
        },
        userId: '',//用户id
        sid: '',//登录账号
        page: 1,
        isLike: false,
        commentIsLike: false,
        commentParams: {
          id: ''
        }
      }
    },
    methods: {
      commentDislike(item) {
        item.commentIsLike = false
        item.greatNum -= 1
        this.commentParams.id = item.id
        let _this = this
        commentMinusGreatCount( this.commentParams.id).then(function (res) {
          if (res.data.flag == 'success') {

          }
        }).catch(function (res) {
          console.log(res);
        })

       /*   _this.$axios.post('/comment/greatCount/minus', this.commentParams.id).then(function(res) {
            if (res.data.flag == 'success') {

            }
          }).catch(function(res) {
            console.log(res);
          })*/
      },
      commentLike(item) {
        item.commentIsLike = true
        item.greatNum += 1
        this.commentParams.id = item.id
        let _this = this

        commentAddGreatCount(this.commentParams.id).then(function (res) {
          if (res.data.flag == 'success') {

          }
        }).catch(function (res) {
          console.log(res);
        })


      },
      dislike() {
        this.isLike = false
        this.detail.detail.greatCount -= 1
        let _this = this
        minusGreatCount(this.params.id, this.params.page, this.params.size, this.params.reply).then(function (res) {
          if (res.data.flag == 'success') {

          }
        }).catch(function (res) {
          console.log(res);
        })
        /* _this.$axios.post('/greatCount/minus', this.params).then(function(res) {
           if (res.data.flag == 'success') {

           }
         }).catch(function(res) {
           console.log(res);
         })*/
      },
      like() {
        this.isLike = true
        this.detail.detail.greatCount += 1
        let _this = this
        addGreatCount(this.params.id, this.params.page, this.params.size, this.params.reply).then(function (res) {
          if (res.data.flag == 'success') {

          }
        }).catch(function (res) {
          console.log(res);
        })
        /*      _this.$axios.post('/greatCount/add', this.params).then(function(res) {
                if (res.data.flag == 'success') {

                }
              }).catch(function(res) {
                console.log(res);
              })*/

      },
      handleReply() {
        //回复帖子
        let _this = this
        if ((localStorage.getItem("casUser") !== null && localStorage.getItem("casUser").length !== 0)) {
          if(this.params.reply == ''){
            _this.$alert('请填写评论内容', {
              confirmButtonText: '确定'
            })
          }else{
            addComment(this.params.id, this.userId, this.sid, "user", this.params.reply).then(res => {
              if (res.status === OK) {
                if (res.data.success == true) {
                  this.$toast({
                    message: '评论成功',
                    duration: 800
                  })
                  _this.params.reply = '';//清空评论内容
                  _this.getDetail()

                } else {
                  Toast('评论失败')
                }
              }
            }).catch(error => {
              console.log("错误" + error);
            })

          }

        } else {
          this.$router.push({
            path: '/pclogin',
            query: {
              redirect: '/casDetail?detailId=' + this.params.id  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            }
          })
        }

      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert("success");
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      // getComments() {
      //   let data = "{\"total\":10,\"data\":[{\"author\":\"author1\",\"follow\":100,\"publish\":20,\"comment\":\"很正确\"},{\"author\":\"author2\",\"follow\":100,\"publish\":20,\"comment\":\"赞同\"}]}";
      //   this.commonts = JSON.parse(data);
      // },
      getDetail() {
        let _this = this
        getPostDetail(this.params.id, this.params.page, this.params.size, this.params.reply,this.sid).then(function (res) {
          if (res.data.flag == 'success') {
            _this.detail = res.data.data;
            console.log("getDetail");
            console.log(_this.detail);
            if (_this.detail.detail.image != '' && _this.detail.detail.image != null) {
              let images = _this.detail.detail.image.split(";")
              for (let i = 0; i < images.length; i++) {
                images[i] = HOST + images[i]
              }
              _this.detail.detail.image = images
            } else {
              _this.detail.detail.image = ''
            }

          }

        }).catch(function (res) {
          console.log(res);
        })


      },
      handleCurrentChange() {
        this.getDetail()
      },
      addBrowseCount() {
        let _this = this
        addBrowseCount(this.params.id, this.params.page, this.params.size, this.params.reply).then(function (res) {
          if (res.data.flag == 'success') {

          }
        }).catch(function (res) {
          console.log(res);
        })

      }
    },
    created() {
      this.params.id = this.$route.query.detailId
      this.getDetail()
      this.addBrowseCount()
    },
    mounted() {
      let data = JSON.parse(localStorage.getItem("casUser"));
      if (data) {
        let token = data.data.token
        this.casAuthorization = token
        this.userInfo = data.data
        this.userId = data.data.id;
        this.sid = data.data.username;
        console.log("sid:"+this.sid);
        //this.ruleForm.name = this.userInfo.studentName

      } else {
        //未登录，跳转到登录页面
        // this.$router.push('/login')
      }
    }

  }
</script>


<style scoped>
  .form_border {
    border: 1px solid grey;
    padding: 5px;
    border-radius: 10px;
  }

  .content {
    /* background: #FBFBFB */
  }

  .DeatilAside {
    /* border:1px solid black; */
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
    margin-right: 10px;
    padding-top: 40px;
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
  }

  .DetailMain {
    border-radius: 10px;
    /* height: 250px; */
    background: rgba(255, 255, 255, 1);
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
  }

  .headPictureWraper {
    text-align: center;
  }

  .headPicture {
    width: 100px;
    height: 100px;
    border: 1px solid white;
    box-shadow: 1px 1px 1px white
  }

  .date {
    position: absolute;
    bottom: 15px;
  }

  .bottom {
    position: absolute;
    bottom: 15px;
    padding-left: 110px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pc/ComplaintsAndSuggestionsDetail.vue